import React from 'react'
import ProductSectionForm from 'ui-shared/Forms/ProductSectionForm'
import { Create } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'

const LocationSectionCreate: React.FC = () => (
  <SectionWrapper title={'resources.locationsections.createSection'}>
    <Create>
      <ProductSectionForm entity="locations" />
    </Create>
  </SectionWrapper>
)

export default LocationSectionCreate
